<template>
    <a-card title="关注的项目"
            class="n-col-1 n-body-shadow"
            ref="followCard"
            :loading="follow.loading">

        <template #extra>
            <a-button type="primary"
                      @click="showAddProject = true">新建工作项目</a-button>
        </template>

        <swiper :modules="modules"
                :slides-per-view="Math.ceil(this.containerWidth / 800)"
                :space-between="10"
                v-if="follow.datas.length > 0"
                navigation>
            <swiper-slide v-for="(item, index) in follow.datas"
                          :key="index">
                <a-card class="n-col-1 n-h-1 n-body-shadow">
                    <template #title>
                        <span @click="goTask(item)"
                              class="n-pointer">{{item.title}}</span>
                    </template>
                    <template #extra>
                        <a-popconfirm title="确认取消关注该项目？"
                                      ok-text="取消关注"
                                      placement="leftTop"
                                      cancel-text="取消"
                                      :disabled="item.loading"
                                      @confirm="changeFollow(item)">
                            <a-button type="link"
                                      danger
                                      :loading="item.loading"
                                      :disabled="item.loading">取消关注</a-button>
                        </a-popconfirm>
                    </template>

                    <div class="chart-container">
                        <div class="chart-title">
                            <h5 class="n-block n-text-center n-c-2">任务</h5>
                            <span class="n-block n-text-center n-f-7">{{item.total}}</span>
                        </div>
                        <div :ref="'followChart' + index"
                             class="chart-container-inner"></div>
                    </div>
                    <a-button type="link"
                              class="view-chart n-f-4 n-c-2"
                              @click="goChart(item)"
                              v-if="item.boardUrl">查看分析报表</a-button>
                </a-card>
            </swiper-slide>
        </swiper>

        <a-empty v-else
                 description='暂无可统计的项目' />

    </a-card>

    <a-row :gutter="[10, 10]"
           :wrap="true"
           class="n-mt-2">
        <a-col :span="24"
               :lg="12">
            <a-card title="我的项目"
                    class="n-col-1 n-h-1 n-body-shadow">
                <template #extra>
                    <router-link :to="{ name: 'myProject'}">更多</router-link>
                </template>

                <a-table :dataSource="project.datas"
                         :columns="project.columns"
                         :showHeader="false"
                         :pagination="false"
                         :loading="project.loading"
                         tableLayout="fixed"
                         size="small"
                         :customRow="customRow">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key == 1">
                            <a-row align="middle"
                                   class="n-pointer"
                                   :gutter="[10]"
                                   @click="goTask(record)">
                                <a-col>
                                    <i class="n-icon n-icon-project n-icon-size-20 n-c-base"></i>
                                </a-col>
                                <a-col>{{ record[1] }}</a-col>
                            </a-row>
                        </template>

                        <template v-if="column.key == 2">
                            <a-row align="middle"
                                   justify="end"
                                   :gutter="[5]">
                                <a-col>
                                    <i class="n-icon n-icon-size-20 c-status"
                                       :class="getStatus(record[2]).icon"></i>
                                </a-col>
                                <a-col class="n-f-2">{{ getStatus(record[2]).title }}</a-col>
                            </a-row>
                        </template>
                    </template>
                </a-table>

            </a-card>
        </a-col>

        <a-col :span="24"
               :lg="12">
            <a-card title="我的任务"
                    class="n-col-1 n-h-1 n-body-shadow">
                <template #extra>
                    <router-link :to="{ name: 'myTask'}">更多</router-link>
                </template>

                <a-table :dataSource="task.datas"
                         :columns="task.columns"
                         :pagination="false"
                         :loading="task.loading"
                         tableLayout="fixed"
                         size="small">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key == 'level'">
                            <a-row align="middle"
                                   :gutter="[5]">
                                <a-col><i class="c-level"
                                       :class="'c-level-' + record.level"></i></a-col>
                                <a-col>{{ getLevel(record.level).title }}</a-col>
                            </a-row>
                        </template>

                        <template v-if="column.key == 'status'">
                            <a-select v-model:value="record.status"
                                      size="small"
                                      class="c-status"
                                      :class="'c-status-' + record.status"
                                      :loading="record.statusLoading"
                                      :options="status.map(item => {item.disabled = item.value == 0; return item})"
                                      @change="updateTaskStatus(record)"></a-select>
                        </template>
                    </template>
                </a-table>

            </a-card>
        </a-col>
    </a-row>

    <AddProjectBox :visible="showAddProject"
                   @close="showAddProject = false"
                   @success="getProject"></AddProjectBox>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';

    import * as echarts from 'echarts/core';
    import { PieChart } from 'echarts/charts';
    import { LabelLayout, UniversalTransition } from 'echarts/features';
    import { CanvasRenderer } from 'echarts/renderers';
    import { TooltipComponent, LegendComponent, TitleComponent } from 'echarts/components';

    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Navigation } from 'swiper';
    import 'swiper/css';
    import 'swiper/css/navigation';

    import AddProjectBox from '@/components/AddProjectBox'

    echarts.use([
        TitleComponent,
        TooltipComponent,
        PieChart,
        LabelLayout,
        UniversalTransition,
        CanvasRenderer,
        LegendComponent
    ]);

    import nui from '@/assets/script';

    export default {
        name: 'Dashboard',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['windowWidth', 'level', 'status'])),
        },
        setup () {
            return {
                modules: [Navigation],
            };
        },
        watch: {
            windowWidth () {
                this.initTot & (clearTimeout(this.initTot))
                this.initTot = setTimeout(this.initChart, 1000);
            }
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                containerWidth: 0,
                initTot: null,

                follow: {
                    loading: false,
                    datas: [],
                },


                project: {
                    loading: false,
                    datas: [],
                    columns: [
                        { title: '1', dataIndex: '1', key: '1' },
                        { title: '2', dataIndex: '2', key: '2', width: 90 }
                    ]
                },

                task: {
                    loading: false,
                    datas: [],
                    columns: [
                        { title: '任务标题', dataIndex: 'title', key: 'title' },
                        { title: '截止日期', dataIndex: 'date', key: 'date', width: 90 },
                        { title: '优先级', dataIndex: 'level', key: 'level', width: 60 },
                        { title: '状态', dataIndex: 'status', key: 'status', width: 90 }
                    ]
                },

                showAddProject: false
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.getFollow()
                this.getProject()
                this.getTask()
            },
            goChart (data) {
                if (this.trims(data.boardUrl, 2).indexOf('http') == 0) {
                    window.open(data.boardUrl)
                } else {
                    this.error('URL不合法');
                }
            },
            /**
             * @description 渲染饼图
             */
            initChart () {
                this.containerWidth = this.$refs.followCard.$el.offsetWidth;

                this.$nextTick(() => {
                    this.follow.datas.forEach((item, index) => {
                        item.chart && (item.chart.dispose())
                        item.chart = echarts.init(this.$refs['followChart' + index][0])
                        item.chart.setOption({
                            tooltip: { trigger: 'item' },
                            avoidLabelOverlap: true,
                            legend: {
                                orient: 'vertical',
                                top: 'center',
                                left: '50%',
                                itemWidth: 8,
                                itemHeight: 8,
                                icon: "circle",
                                textStyle: {
                                    fontSize: 16
                                },
                                formatter: (name) => {
                                    var total = 0, current = 0;

                                    item.datas.forEach((item, index) => {
                                        if (item.name == name) {
                                            current = item.value
                                        }

                                        total += item.value;
                                    })

                                    var percent = parseFloat(current / total * 100).toFixed(2),
                                        preFix = '';

                                    if (parseFloat(percent) < 1) {
                                        preFix = '    '
                                    } else if (parseFloat(percent) < 10) {
                                        preFix = '    '
                                    } else if (parseFloat(percent) < 100) {
                                        preFix = '  '
                                    }

                                    return name + '   ' + preFix + percent + '%    ' + current;
                                }
                            },
                            color: ['#37a965', '#4870ff', '#00dbff', '#F4D06D', '#c72676'],
                            series: [{
                                name: 'followChart',
                                type: 'pie',
                                radius: ['40%', '75%'],
                                width: '50%',
                                itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 3 },
                                label: { show: true, position: 'inside', formatter: '{c}' },
                                data: item.datas
                            }]
                        })
                    })
                })
            },
            /**
             * @description 关注项目
             */
            getFollow () {
                this.follow.loading = true;

                this.request(this.API.followProject).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        // res.data = [res.data[0], res.data[0], res.data[0], res.data[0], res.data[0], res.data[0]]

                        this.follow.datas = res.data.map((item, index) => {
                            return {
                                id: item.projectId,
                                title: item.projectName,
                                chart: null,
                                total: item.finishCount + item.dongCount + item.unStartCount + item.overdueCount + (item.suspendCount || 0),
                                loading: false,
                                boardUrl: item.boardUrl,
                                datas: [
                                    { value: item.finishCount, name: '已完成' },
                                    { value: item.dongCount, name: '进展中' },
                                    { value: item.unStartCount, name: '未开始' },
                                    { value: item.suspendCount || 0, name: '暂停中' },
                                    { value: item.overdueCount, name: '已过期' }
                                ]
                            }
                        })

                        this.$nextTick(this.initChart)

                        this.follow.loading = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
            * @description 修改关注状态
            */
            changeFollow (data) {
                data.loading = true;

                this.request(this.API.follow, {
                    params: {
                        projectId: data.id
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.follow.datas = this.follow.datas.filter(item => item.id != data.id);
                        data.loading = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 我的项目
             */
            getProject () {
                this.project.loading = true;

                this.request(this.API.myProject, {
                    method: 'post',
                    data: {
                        pageCount: 1,
                        pageSize: 7
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.project.datas = res.data.list.map(item => {
                            return { key: item.id, id: item.id, 1: item.projectName, 2: item.progressStatus }
                        })

                        this.project.loading = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 我的任务
             */
            getTask () {
                // TODO
                this.request(this.API.myTask).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        var task = [];

                        res.data.forEach((item, index) => {
                            var list = item.taskVoList.map(sItem => {
                                sItem.status = item.status;
                                return sItem
                            })

                            task = task.concat(list)
                        })

                        task = task.sort((a, b) => new Date(a.endTime).getTime() - new Date(b.endTime).getTime())

                        this.task.datas = task.map((item, index) => {
                            return { key: item.taskId, title: item.taskName, date: this.parseUTC(item.endTime), level: item.priority, status: item.status, loading: false }
                        })
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 更新任务状态
             */
            updateTaskStatus (data) {
                data.statusLoading = true;

                this.request(this.API.updateTaskStatus, {
                    method: 'post',
                    data: { taskId: data.key, status: this.task.datas.filter(item => item.key == data.key)[0].status }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('更新状态成功')
                        data.statusLoading = false;
                    } else {
                        this.error(res.msg)
                    }
                })
            },
            goTask (data) {
                this.$router.push({ name: 'projectTask', query: { id: data.id } })
            },
            customRow (record) {
                return {
                    onClick: () => {
                        this.goTask(record)
                    }
                }
            }
        }),
        components: {
            AddProjectBox,
            Swiper,
            SwiperSlide,
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss">
    .chart-container {
        padding-bottom: 60%;
        position: relative;

        .chart-title {
            position: absolute;
            top: 50%;
            left: 25%;
            transform: translate(-50%, -50%);
        }

        .chart-container-inner {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
        }
    }

    .view-chart {
        position: absolute !important;
        bottom: 0;
        right: 0;
    }

    .swiper-button-next,
    .swiper-button-prev {
        transform: translateY(50%);
    }
</style>